import { Button } from "@/components/ui/button";
import { Field, FieldGroup, FieldLabel, FieldSet } from "@/components/ui/field";
import { Input } from "@/components/ui/input";

interface EmailStepProps {
  email: string;
  onEmailChange: (value: string) => void;
  onContinue: () => void;
  notFound: boolean;
  pending: boolean;
  error?: string;
}

const EmailStep = ({ email, onEmailChange, onContinue, notFound, pending, error }: EmailStepProps) => (
  <form onSubmit={(e) => { e.preventDefault(); onContinue(); }}>
    <FieldSet>
      <FieldGroup>
        {notFound && (
          <div className="p-4 text-sm text-red-700 bg-red-100 rounded-lg dark:bg-red-200 dark:text-red-800" role="alert">
            We couldn&apos;t find an account with that email. Please check it, or contact your practice manager.
          </div>
        )}
        {error && (
          <div className="p-4 text-sm text-red-700 bg-red-100 rounded-lg dark:bg-red-200 dark:text-red-800" role="alert">
            {error}
          </div>
        )}
        <Field>
          <FieldLabel htmlFor="email">Email address</FieldLabel>
          <Input
            id="email"
            type="email"
            placeholder="Enter your email address"
            className="bg-white dark:text-gray-900 text-lg"
            value={email}
            onChange={(e) => onEmailChange(e.target.value)}
          />
        </Field>
        <Field orientation="horizontal">
          <Button type="submit" className="w-full" disabled={!email || pending} aria-label="Continue">
            Continue
          </Button>
        </Field>
      </FieldGroup>
    </FieldSet>
  </form>
);

export default EmailStep;
